import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, interval, switchMap, map } from 'rxjs';
import { Lesson, CreateLessonResponse } from 'app/models/lessons.model';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';
import { unwrapLessonReferencesList } from '@app/utils/vio-api-response';

@Injectable({
  providedIn: 'root'
})
export class SMELessonService {

  // private apiUrl = 'http://localhost:3000/api/projects'; // Adjust your endpoint

  private baseUrl = `${environment.baseUrl}/lessonMgmt`;

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }


  getLessons(userId: number, lessonLifecycleFilter?: string | null): Observable<any> {
    console.log("getting lessons for user id " + userId);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const criteria: Record<string, unknown> = {
      userId,
      tenant: null,
    };
    if (lessonLifecycleFilter) {
      criteria['lessonLifecycleFilter'] = lessonLifecycleFilter;
    }
    const body = {
      criteria,
    };

    // let aaa = this.http.post(`${this.baseUrl}/lessonsList`, body, { headers });


    // console.log(aaa);
    // return aaa;

    return this.commonAPI.postApiCall(`${this.baseUrl}/lessonsList`, body);

    //return this.http.get(`${this.baseUrl}/batches?`,query );
  }


  copyLesson(userId: number, lessonId: number): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userId,
        "lessonId": lessonId,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/copylesson`, body);
    // return this.http.post(`${this.baseUrl}/copylesson`, body, { headers });

    //return this.http.get(`${this.baseUrl}/batches?`,query );
  }


  generatePPT(userId: number, lessonId: number, lessontype: string): Observable<any> {
    console.log("enetered generate PPT");
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userId,
        "lessonId": lessonId,
        "lessontype": lessontype,
        "tenant": null
      }
    };
    console.log(body);
    return this.commonAPI.postApiCall(`${this.baseUrl}/generatePPT`, body);
    // return this.http.post(`${this.baseUrl}/generatePPT`, body, { headers });

    //return this.http.get(`${this.baseUrl}/batches?`,query );
  }

  updateLessonLifecycle(userId: number, lessonId: number, lessonLifecycleStatus: string): Observable<any> {
    const body = {
      criteria: {
        userId,
        lessonId,
        lessonLifecycleStatus,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/updateLessonLifecycle`, body);
  }

  getLessonMeta(userId: number, lessonId: number): Observable<any> {
    // debugger;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userId,
        "lessonId": lessonId,
        "tenant": null
      }
    };

    // let aaa = this.http.post<Lesson>(`${this.baseUrl}/getLesson`, body, { headers });
    // return aaa;

    return this.commonAPI.postApiCall(`${this.baseUrl}/getLesson`, body);
    //return this.http.get<any>(`${this.baseUrl}/${lessonId}`);
  }

  getLicenseAvailability(userId: number): Observable<any> {
    const body = {
      criteria: {
        userId,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/getLicenseAvailability`, body);
  }

  createLesson(userId: number, payload: any): Observable<Lesson> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userId,
        "lessonData": payload,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/createLesson`, body);
    // return this.http.post<Lesson>(`${this.baseUrl}/createLesson`, body, { headers });
    // return this.http.put(`${this.baseUrl}/${lessonId}`, payload);
  }

  /** AI-assisted lesson field extraction for SME chat (OpenAI on backend). */
  interpretSmeLessonChat(
    userId: number,
    userMessage: string,
    partialLessonData: any | null
  ): Observable<{
    assistantMessage: string;
    lessonData: any;
    missingMandatory: string[];
    readyToCreate: boolean;
  }> {
    const body = {
      criteria: {
        userId,
        userMessage,
        partialLessonData,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/interpretSmeLessonChat`, body);
  }


  updateLessonMeta(userId: number, lessonId: number, payload: any): Observable<Lesson> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
        "userId": userId,
        "lessonId": lessonId,
        "lessonData": payload,
        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.baseUrl}/updateLesson`, body);

    // return this.http.post<Lesson>(`${this.baseUrl}/updateLesson`, body, { headers });
    // return this.http.put(`${this.baseUrl}/${lessonId}`, payload);
  }




  /** POST body.criteria; Data is `{ references: [...] }` or a row array. */
  listLessonReferences(userId: number, lessonId: number): Observable<unknown[]> {
    const body = {
      criteria: {
        userId,
        lessonId,
        tenant: null,
      },
    };
    return this.commonAPI
      .postApiCall(`${this.baseUrl}/listLessonReferences`, body)
      .pipe(map((res) => unwrapLessonReferencesList(res)));
  }

  uploadLessonReference(
    userId: number,
    lessonId: number,
    fileName: string,
    fileBase64: string,
    opts?: {
      label?: string;
      mimeType?: string;
      useForToc?: string;
      useForSlides?: string;
      referenceRole?: 'supplemental' | 'primary';
    },
  ): Observable<unknown> {
    const body = {
      criteria: {
        userId,
        lessonId,
        fileName,
        fileBase64,
        label: opts?.label,
        mimeType: opts?.mimeType,
        useForToc: opts?.useForToc,
        useForSlides: opts?.useForSlides,
        referenceRole: opts?.referenceRole,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/uploadLessonReference`, body);
  }

  deleteLesson(userId: number, lessonId: number): Observable<unknown> {
    const body = {
      criteria: {
        userId,
        lessonId,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/deleteLesson`, body);
  }

  deleteLessonReference(userId: number, lessonId: number, refId: string): Observable<unknown> {
    const body = {
      criteria: {
        userId,
        lessonId,
        refId,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/deleteLessonReference`, body);
  }

  updateLessonReference(
    userId: number,
    lessonId: number,
    refId: string,
    patch: {
      useForToc?: 'Y' | 'N';
      useForSlides?: 'Y' | 'N';
      referenceRole?: 'supplemental' | 'primary';
    },
  ): Observable<unknown> {
    const body = {
      criteria: {
        userId,
        lessonId,
        refId,
        patch,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/updateLessonReference`, body);
  }

  /** Re-upload expired OpenAI file_ids for lesson references (15-day expires_after). */
  refreshLessonReferenceOpenAi(userId: number, lessonId: number): Observable<unknown> {
    const body = {
      criteria: {
        userId,
        lessonId,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/refreshLessonReferenceOpenAi`, body);
  }

  /**
   * Update lesson meta. Nested criteria.lessonData is intentional (BE updateLesson).
   * Previously incorrectly posted to getLessonSlide — fixed to updateLesson.
   */
  editLesson(userId: number, lessonId: number, payload: any): Observable<any> {
    console.log('editing lesson for user id ' + userId);
    console.log(payload);
    const body = {
      criteria: {
        userId,
        lessonId,
        lessonData: payload,
        tenant: null,
      },
    };
    return this.commonAPI.postApiCall(`${this.baseUrl}/updateLesson`, body);
  }

}
